module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_white-15a7420e19f8db9a76f56cbaaa100ec4.svg";